<!-- src/components/Home.vue -->
<template>
  <div>
    <HeroSection id="hero" />
    <AboutUs id="about" />
    <Bohnen id="bohnen" />
    <NeuerStandortSection id="neuer-standort" />
    <Gallery id="gallery" />
    <MenuSection id="menu" />
    <ContactSection id="contact" />
    <Shop id="Shop" />
  </div>
</template>

<script>
import HeroSection from './HeroSection.vue';
import AboutUs from './AboutUs.vue';
import Bohnen from './Bohnen.vue';
import NeuerStandortSection from './NeuerStandortSection.vue';
import Gallery from './Gallery.vue';
import ContactSection from './ContactSection.vue';
import Shop from './Shop.vue';


export default {
  name: 'Home',
  components: {
    HeroSection,
    AboutUs,
    Bohnen,
    NeuerStandortSection,
    Gallery,
    ContactSection,
    Shop
  }
};
</script>

<style>
/* Stile für Home-Seite */
</style>
